module.exports = __webpack_public_path__ + "img/arrow.0dcdeeb1.svg";